import React from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './footer-gray.css'

const FooterGray = (props) => {
  return (
    <footer className={`footer-gray-footer ${props.rootClassName} `}>
      <div className="footer-gray-divider"></div>
      <div className="footer-gray-container1">
        <div className="footer-gray-container2">
          <div className="footer-gray-container3">
            <span className="footer-gray-text1">BETTER CALL AI</span>
            <span className="footer-gray-text2">
              La meilleure façon de prendre rendez-vous
            </span>
            <div className="footer-gray-container4">
              <a
                href="https://www.linkedin.com/company/100884211"
                target="_blank"
                rel="noreferrer noopener"
                className="footer-gray-link1"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  className="footer-gray-icon1"
                >
                  <path
                    d="M26.2 4H5.8C4.8 4 4 4.8 4 5.7v20.5c0 .9.8 1.7 1.8 1.7h20.4c1 0 1.8-.8 1.8-1.7V5.7c0-.9-.8-1.7-1.8-1.7M11.1 24.4H7.6V13h3.5zm-1.7-13c-1.1 0-2.1-.9-2.1-2.1s.9-2.1 2.1-2.1c1.1 0 2.1.9 2.1 2.1s-1 2.1-2.1 2.1m15.1 12.9H21v-5.6c0-1.3 0-3.1-1.9-3.1S17 17.1 17 18.5v5.7h-3.5V13h3.3v1.5h.1c.5-.9 1.7-1.9 3.4-1.9c3.6 0 4.3 2.4 4.3 5.5v6.2z"
                    fill="currentColor"
                  ></path>
                </svg>
              </a>
            </div>
            <a
              href={props.linkedInUrl}
              target="_blank"
              rel="noreferrer noopener"
              className="footer-gray-link2"
            >
              <img
                alt={props.linkedInAlt}
                src={props.linkedInSrc}
                className="social"
              />
            </a>
          </div>
          <div className="footer-gray-container5">
            <div className="footer-gray-container6">
              <span className="footer-gray-text3 Large">A propos</span>
              <Link to="/cgu" className="footer-gray-navlink1 Large">
                Conditions Générales d&apos;Utilisation
              </Link>
              <Link to="/cgu" className="footer-gray-navlink2 Large">
                Politique de confidentialité
              </Link>
            </div>
            <div className="footer-gray-container7">
              <span className="footer-gray-text4 Large">Entreprise</span>
              <Link to="/contact" className="footer-gray-navlink3 Large">
                Nous rejoindre
              </Link>
              <Link to="/contact" className="footer-gray-navlink4 Large">
                Devenir partenaire
              </Link>
            </div>
          </div>
        </div>
        <span className="footer-gray-text5">
          All rights reserved. Copyright © 2024 BetterCallAI
        </span>
      </div>
    </footer>
  )
}

FooterGray.defaultProps = {
  linkedInSrc: '/external/linkedin-200h-200h.png',
  rootClassName: '',
  linkedInAlt: 'image',
  linkedInUrl: 'https://www.linkedin.com/company/better-call-ai',
}

FooterGray.propTypes = {
  linkedInSrc: PropTypes.string,
  rootClassName: PropTypes.string,
  linkedInAlt: PropTypes.string,
  linkedInUrl: PropTypes.string,
}

export default FooterGray
